import React, { useEffect, useState } from "react";
import "../styles/InstructionPageStyles.css"; // Import your CSS file for styling
import Timer from "../../../assets/images/assessment_instruction/timer.png";
import Minutes from "../../../assets/images/assessment_instruction/minutes.png";
import Abcd from "../../../assets/images/assessment_instruction/abcd.png";
import Flag from "../../../assets/images/assessment_instruction/flag.png";
import Report from "../../../assets/images/assessment_instruction/report.png";
import Submit from "../../../assets/images/assessment_instruction/submit.png";
import Headphone from "../../../assets/images/assessment_instruction/webcam.svg";
import Invalid from "../../../assets/images/assessment_instruction/invalid.png";
import { useLocation, useNavigate } from "react-router-dom";
import strings from "../../../utils/Strings";
import { JSX } from "react/jsx-runtime";
import GenericModal from "../../../components/GenericModalComponent";
import NewWindow from "react-new-window";
import Logger from "../../../utils/Logger";
import { useAlert } from "../../../components/AlertContextComponent";
import { useDispatch, useSelector } from "react-redux";
import { setDuration } from "../data/redux/AssessmentSlice";
import { RootState } from "../../../store/store";
import jozunaLogo from "../../../assets/images/sidebarImages/logo.svg";
import { LocalStorage } from "../../../utils/Utils";
import BackImg from "../assets/cameracheck/back.png";
import AssessmentDetailsComponent from "../components/AssessmentDetailsComponent";
import AssessmentQuestionModuleApiService from "../../assessment_question/data/api_services/QuestionModuleApi";
import AssessmentNewWindowComponent from "../components/AssessmentNewWindowComponent";

const AssessmentInstructions: React.FC = () => {
  const [isAccepted, setIsAccepted] = useState(false);
  const navigate = useNavigate();
  const questionModuleApiService = AssessmentQuestionModuleApiService();
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [duration, setDurations] = useState<string | null>(
    LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.duration,
    ),
  );
  const [status, setStatus] = useState<string>("");

  const [modalContent, setModalContent] = useState<React.ReactNode>("");
  //new window component implementation starts
  const [isChildWindowOpen, setIsChildWindowOpen] = useState(false);
  const [dataToPass, setDataToPass] = useState({ name: "Kalpana", age: 21 });
  const [blurCount, setBlurCount] = useState(0); // To track how many times the user goes out
  const [isHalfSize, setIsHalfSize] = useState(false); // To track if window is resized to half size
  const userData = useSelector((state: RootState) => state.profile.profileKeys); //To show favicon & title

  //Tab Changes detection
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isForcedExit, setIsForcedExit] = useState(false); // Indicates user has been logged out
  const { showAlert } = useAlert();
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsAccepted(e.target.checked);
  };
  const dispatch = useDispatch();
  const handleClose = () => {
    setModalShow(false);
  };
  const [assessmentWindow, setAssessmentWindow] = useState<Window | null>(null);
  const handleNextClick = () => {
    if (!isAccepted) {
      alert("Please accept the Terms & Conditions to start the assessment.");
    } else {
      // Proceed to the next step
      handleOpenChildWindow();
    }
  };
  //   const handleGoBack = () => {
  //     navigate(-1);
  //   };
  const handleShowModal = (title: string) => {
    setModalTitle(title);
    if (title === strings.modal.Terms) {
      setModalContent(
        <div>
          <ul>
            <li>
              The assessment is only used to develop and mature the platform and
              not for anyone's consumption.
            </li>
            <li>
              The data collected will be used to build and enhance our platform.
            </li>
            <li>
              The email information for the user is used only to send the
              assessment report and not for any marketing purpose at this point
              in time.
            </li>
            <li>
              The user can unsubscribe from the assessment report at any time by
              clicking the "Unsubscribe" button.
            </li>
          </ul>
        </div>,
      );
    }

    setModalShow(true);
  };

  const handleOpenChildWindow = () => {
    setIsChildWindowOpen(true);
    Logger.info("Child window value", isChildWindowOpen);
  };

  // Function to attach event listeners to the new window
  const attachEventListeners = (newWindow: Window) => {
    // Disable right-click
    newWindow.document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });

    // Disable copy, cut, paste and show alert in new window
    newWindow.document.addEventListener("copy", (e) => {
      e.preventDefault();
      newWindow.alert("Copying is disabled");
    });
    newWindow.document.addEventListener("cut", (e) => {
      e.preventDefault();
      newWindow.alert("Cutting is disabled");
    });
    newWindow.document.addEventListener("paste", (e) => {
      e.preventDefault();
      newWindow.alert("Pasting is disabled");
    });

    // Listen to when the user leaves the new window (blur)
    newWindow.addEventListener("blur", () => {
      setBlurCount((prevCount) => {
        const newCount = prevCount + 1;
        if (newCount === 4) {
          setIsPopupVisible(false);
          setIsForcedExit(true); // Prevent further interactions
        } else {
          setIsPopupVisible(true);
        }
        return newCount;
      });
    });
  };

  //new window component implementation ends
  const fetchAssessmentStatus = () => {
    questionModuleApiService.fetchAssessmentStatus({
      onInProgress: (assessment) => {
        assessment.status && setStatus(assessment.status);

        dispatch(setDuration(assessment.duration!));
        assessment.duration && setDurations(assessment.duration.toString());
        assessment.duration &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.duration,
            assessment.duration.toString(),
          );
        assessment.status &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.status,
            assessment.status,
          );
        assessment.assessment_id &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.assessment_id,
            assessment.assessment_id.toString(),
          );
        assessment.current_counter &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.current_counter,
            assessment.current_counter.toString(),
          );
        assessment.total_question &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.total_question,
            assessment.total_question.toString(),
          );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.isIndependent,
          assessment.isIndependent === null ||
            assessment.isIndependent === undefined
            ? "true"
            : assessment.isIndependent.toString(),
        );
      },
      onNotStarted: (assessment) => {
        assessment.duration && setDurations(assessment.duration.toString());
        assessment.detail && setStatus(assessment.detail);

        assessment.detail &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.status,
            assessment.detail,
          );
        assessment.total_question &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.total_question,
            assessment.total_question.toString(),
          );
      },
    });
  };

  useEffect(() => {
    Logger.info("Status state", status);
  }, [status]);
  useEffect(() => {
    //Assessment Status Handling
    // fetchAssessmentStatus();
    // Define event handlers
    // const handleOnline = () => {
    //   setIsOnline(true);
    //   setShowPopup(false); // Close the popup when online
    // };
    // const handleOffline = () => {
    //   setIsOnline(false);
    //   setShowPopup(true); // Open the popup when offline
    //   showAlert({
    //     show: true,
    //     title: "Error",
    //     message:
    //       "The system has detected that there is no internet connection. Don’t worry! Please close the window and resume the assessment when you're ready@@@@@.",
    //     alertType: "error",
    //     onlyNeedOneButton: true,
    //     button1Text: "OK",
    //   });
    // };
    // // Add event listeners
    // window.addEventListener("online", handleOnline);
    // window.addEventListener("offline", handleOffline);
    // // Cleanup event listeners
    // return () => {
    //   window.removeEventListener("online", handleOnline);
    //   window.removeEventListener("offline", handleOffline);
    // };
  }, []);
  const location = useLocation();
  const { assessmentList, selectedAssessment } = location.state || {};

  return (
    <div>
      <div className="assessment-header">
        <div className="header-content">
          <img
            src={BackImg}
            className="back-btn"
            onClick={() => {
              if (
                selectedAssessment.candidate_assessment_status ===
                  strings.assessment_status.inProgress ||
                selectedAssessment.candidate_assessment_status ===
                  strings.assessment_status.initated
              ) {
                navigate("/dashboard/assessment/cameracheck", {
                  state: {
                    selectedAssessment: selectedAssessment,
                  },
                });
              } else {
                navigate("/dashboard/assessment/cameracheck/otp", {
                  state: {
                    selectedAssessment: selectedAssessment,
                  },
                });
              }
            }}
          ></img>
          <span className="title">{"Assessment"}</span>
        </div>
        <div className="divider" />
      </div>
      <div className="instruct-assessment-container">
        <AssessmentDetailsComponent selectedAssessment={selectedAssessment} />
        <div className="right-panel">
          <div className="instructionss-container">
            <p className="instructcheck-bestwish">
              All the best! {userData.first_name} {userData.last_name}...
            </p>
            <div className="instruction-cards">
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  {" "}
                  <img
                    src={Minutes}
                    alt="Clock"
                    className="instructimage-card"
                  />
                  <p>
                    You will get only{" "}
                    <span className="instructcard-boldfont">
                      {selectedAssessment?.assessment_duration} minutes
                    </span>{" "}
                    based on the complexity of questions curated. Here{" "}
                    <span className="instructcard-boldfont">
                      {selectedAssessment?.assessment_duration}
                    </span>{" "}
                    is the number of minutes configured for the assessment.
                  </p>
                </div>
              </div>
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  {" "}
                  <img src={Abcd} alt="MCQ" className="instructimage-card" />
                  <p>
                    Users will be presented with questions of{" "}
                    <span className="instructcard-boldfont">
                      multiple choice
                    </span>{" "}
                    and{" "}
                    <span className="instructcard-boldfont">
                      descriptive type
                    </span>
                    .
                  </p>
                </div>
              </div>
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  <img src={Timer} alt="Timer" className="instructimage-card" />
                  <p>
                    You will be shown the{" "}
                    <span className="instructcard-boldfont">
                      overall time remaining
                    </span>{" "}
                    for your assessment. The timer is movable for your
                    convenience.
                  </p>
                </div>
              </div>
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  <img
                    src={Flag}
                    alt="Revisit"
                    className="instructimage-card"
                  />
                  <p>
                    You will have an option to{" "}
                    <span className="instructcard-boldfont">
                      re-visit the question
                    </span>{" "}
                    that you need to answer later.
                  </p>
                </div>
              </div>
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  <img
                    src={Report}
                    alt="Report"
                    className="instructimage-card"
                  />
                  <p>
                    Your{" "}
                    <span className="instructcard-boldfont">
                      assessment report
                    </span>{" "}
                    details will be available in your Dashboard shortly.
                  </p>
                </div>
              </div>
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  <img
                    src={Submit}
                    alt="Submit"
                    className="instructimage-card"
                  />
                  <p>
                    When you{" "}
                    <span className="instructcard-boldfont">
                      run out of time
                    </span>{" "}
                    the assessment will be auto-submitted.
                  </p>
                </div>
              </div>
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  {" "}
                  <img
                    src={Headphone}
                    alt="Camera"
                    className="instructimage-card"
                  />
                  <p>
                    Your{" "}
                    <span className="instructcard-boldfont">
                      camera & microphone
                    </span>{" "}
                    should be turned on during the assessment.
                  </p>
                </div>
              </div>
              <div className="instructcard">
                {/* <div className="instructcard-background"></div> */}
                <div className="instructcard-content">
                  <img
                    src={Invalid}
                    alt="Invalid"
                    className="instructimage-card"
                  />
                  <p>
                    Your assessment will be{" "}
                    <span className="instructcard-boldfont">invalidated</span>{" "}
                    if you tab out or close the browser.
                  </p>
                </div>
              </div>
            </div>

            <div className="terms-container">
              <input
                type="checkbox"
                id="terms"
                checked={isAccepted}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="terms">
                I accept the
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleShowModal("Terms and Conditions");
                  }}
                  // onClick={() => handleShowModal("Terms and Conditions")}
                >
                  {" "}
                  Terms & Conditions
                </a>
              </label>
            </div>
            {!isAccepted && (
              <div className="terms-condiError">
                <p className="error-message">
                  * Please do accept T&C to start assessment
                </p>
              </div>
            )}
            <div className="instruction-btn-background">
              <button
                className="instructionprimary-next-button"
                // onClick={handleNextClick}
                onClick={() => {
                  if (
                    LocalStorage.getLocalData(
                      strings.localStorage_keys.assessment_details
                        .candidate_assessment_status,
                    ) !== null &&
                    LocalStorage.getLocalData(
                      strings.localStorage_keys.assessment_details
                        .candidate_assessment_status,
                    ) !== undefined
                  ) {
                    Logger.info("FIRST");
                    if (
                      LocalStorage.getLocalData(
                        strings.localStorage_keys.assessment_details
                          .candidate_assessment_status,
                      ) === strings.assessment_status.notStarted
                    ) {
                      Logger.info("SECOND");

                      //Start Assessment
                      //Resume Assessment
                      setIsChildWindowOpen(true);
                      //   navigate("otp", {
                      //     state: {
                      //       selectedAssessment: selectedAssessment, // pass your full list here
                      //     },
                      //   });
                    } else {
                      Logger.info("THIRD");

                      //Resume Assessment
                      setIsChildWindowOpen(true);
                    }
                  } else {
                    Logger.info("ELSE BLOCK");
                  }
                }}
                disabled={!isAccepted}
              >
                {/* {localStorage.getItem(strings.localStorage_keys.assessment_details.status) === strings.assessment_status.inProgress ||status===strings.assessment_status.initated
            ? "Resume Assessment"
            : "Next" } */}

                {selectedAssessment.candidate_assessment_status === ""
                  ? ""
                  : selectedAssessment.candidate_assessment_status ===
                        strings.assessment_status.inProgress ||
                      selectedAssessment.candidate_assessment_status ===
                        strings.assessment_status.initated
                    ? "Resume Assessment"
                    : "Start Assessment"}
              </button>
            </div>
            {/* <button
              className="instructionsecondary-btn"
              onClick={() => {
                navigate("/dashboard/assessment");
              }}
            >
              Let me do it later
            </button> */}
            <GenericModal
              show={modalShow}
              handleClose={() => handleClose()}
              title={modalTitle}
              content={modalContent}
            />
            {isChildWindowOpen && (
              <NewWindow
                copyStyles={false}
                onUnload={() => {
                  // setAssessmentWindow(null);
                  setIsChildWindowOpen(false);
                }}
                onOpen={(newWindow) => {
                  // setAssessmentWindow(newWindow);
                  // Efficiently copy stylesheets to the new window without freezing the thread
                  try {
                    const headFrag =
                      newWindow.document.createDocumentFragment();
                    document
                      .querySelectorAll('link[rel="stylesheet"], style')
                      .forEach((el) => {
                        headFrag.appendChild(el.cloneNode(true));
                      });
                    newWindow.document.head.appendChild(headFrag);
                  } catch (e) {
                    Logger.error("Failed to copy styles to child window:", e);
                  }
                  //Disabled the warning of tabChange in dev.As a reason of QA Automation
                  if (process.env.REACT_APP_ENVIORNMENT !== "DEVELOPMENT") {
                    attachEventListeners(newWindow);
                  }
                  // Set the title of the new window
                  if (userData.institute_name) {
                    newWindow.document.title = userData.institute_name;
                  } else {
                    newWindow.document.title = strings.jozuna;
                  }
                  // Set the favicon for the new window
                  if (userData.favicon_url) {
                    const favicon = newWindow.document.createElement("link");
                    favicon.rel = "icon";
                    favicon.href = userData.favicon_url;
                    newWindow.document.head.appendChild(favicon);
                  } else {
                    const favicon = newWindow.document.createElement("link");
                    favicon.rel = "icon";
                    favicon.href = jozunaLogo;
                    newWindow.document.head.appendChild(favicon);
                  }
                  // Disable right-click
                  newWindow.document.addEventListener("contextmenu", (e) =>
                    e.preventDefault(),
                  );
                  const disableKeys = (e: KeyboardEvent) => {
                    if (
                      e.ctrlKey &&
                      (e.key === "I" ||
                        e.key === "J" ||
                        e.key === "U" ||
                        e.key === "S" ||
                        e.key === "P" ||
                        e.key === "C")
                    ) {
                      e.preventDefault();
                    }
                  };

                  // // Helper function to create black screen overlay
                  const createBlackScreenOverlay = (newWindow: any) => {
                    const overlay = newWindow.document.createElement("div");
                    overlay.style.position = "absolute";
                    overlay.style.top = "0";
                    overlay.style.left = "0";
                    overlay.style.width = "100%";
                    overlay.style.height = "100%";
                    overlay.style.backgroundColor = "black";
                    overlay.style.zIndex = "1000"; // Make sure it's on top
                    overlay.id = "blackScreenOverlay"; // Assign an ID for easy removal
                    newWindow.document.body.appendChild(overlay);
                  };

                  const removeBlackScreenOverlay = (newWindow: any) => {
                    const overlay =
                      newWindow.document.getElementById("blackScreenOverlay");
                    if (overlay) {
                      newWindow.document.body.removeChild(overlay);
                    }
                  };

                  const handleKeyDown = (e: KeyboardEvent) => {
                    if (
                      (e.key === "Meta" && e.code === "") ||
                      e.key === "F12"
                    ) {
                      e.preventDefault();
                      createBlackScreenOverlay(newWindow); // Apply black screen on Meta key
                    }
                  };
                  // Handle 'Ctrl+P' key press
                  const handleKeyDowns = (e: KeyboardEvent) => {
                    if (e.ctrlKey && e.key === "p") {
                      e.preventDefault(); // Disable print dialog
                      createBlackScreenOverlay(newWindow); // Apply black screen overlay
                    } // Remove black overlay after a delay (e.g., 3 seconds)
                    setTimeout(() => {
                      removeBlackScreenOverlay(newWindow);
                    }, 3000); // Change 3000 to any other value in milliseconds (3 seconds)
                  };

                  // Handle print events
                  const handleBeforePrint = () => {
                    createBlackScreenOverlay(newWindow); // Apply black screen before print
                  };

                  const handleAfterPrint = () => {
                    removeBlackScreenOverlay(newWindow); // Remove black screen after print
                  };

                  // Handle page visibility change (optional for blur effect)
                  const handleVisibilityChange = () => {
                    if (document.hidden) {
                      document.body.style.filter = "blur(100px)";
                    } else {
                      document.body.style.filter = "none";
                    }
                  };
                  if (process.env.REACT_APP_ENVIORNMENT === "PRODUCTION") {
                    // Add event listeners

                    window.addEventListener("beforeprint", handleBeforePrint);
                    window.addEventListener("afterprint", handleAfterPrint);
                    document.addEventListener(
                      "visibilitychange",
                      handleVisibilityChange,
                    );
                    newWindow.document.addEventListener("keydown", disableKeys); // Disable other keys
                    newWindow.document.addEventListener(
                      "keydown",
                      handleKeyDowns,
                    ); // Disable 'Ctrl+P' print
                    newWindow.document.addEventListener(
                      "keydown",
                      handleKeyDown,
                    ); // Disable 'Ctrl+P' print
                  }
                  // Remove black screen when the window is focused
                  newWindow.addEventListener("focus", () => {
                    removeBlackScreenOverlay(newWindow);
                    window.removeEventListener(
                      "beforeprint",
                      handleBeforePrint,
                    );
                    window.removeEventListener("afterprint", handleAfterPrint);
                    document.removeEventListener(
                      "visibilitychange",
                      handleVisibilityChange,
                    );
                  });
                }}
                features={{
                  width: window.screen.width, // Full screen width
                  height: window.screen.height, // Full screen height
                  left: 0,
                  top: 0,
                }}
                name="childWindow"
                title="Child Window"
              >
                {/* Passing data to ChildComponentPac */}
                <AssessmentNewWindowComponent
                  selectedAssessment={selectedAssessment}
                  data={dataToPass}
                  isHalfSize={isHalfSize}
                  isChildWindowOpen={isChildWindowOpen}
                  setIsChildWindowOpen={setIsChildWindowOpen}
                  isPopupVisible={isPopupVisible}
                  isForcedExit={isForcedExit}
                  setIsPopupVisible={setIsPopupVisible}
                  setIsForcedExit={setIsForcedExit}
                  //assessmentWindow={assessmentWindow}
                />
                {/* <Offline></Offline> */}
              </NewWindow>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentInstructions;

function setModalTitle(title: string) {
  throw new Error("Function not implemented.");
}
function setModalContent(arg0: JSX.Element) {
  throw new Error("Function not implemented.");
}

function setModalShow(arg0: boolean) {
  throw new Error("Function not implemented.");
}
